import { combineReducers } from "@reduxjs/toolkit";
import modalReducer from "./modalReducer";
import userReducer from "./userReducer";
import snackBarReducer from "./snackbarReducer";
import lifeTimestockCountReducer from "./lifeTimestockCountReducer";
import inventoryCountReducer from "./inventoryCountReducer";
import productCategoryReducer from "./productCategoryReducer";
import PatientReducer from "./patientReducer";
import notificationReducer from "./notificationReducer";

const rootReducer = combineReducers({
  user: userReducer,
  modal: modalReducer,
  snackBar: snackBarReducer,
  inventoryCount: inventoryCountReducer,
  lifeStockCount: lifeTimestockCountReducer,
  productCategory: productCategoryReducer,
  patientDetail: PatientReducer,
  notifications: notificationReducer
});
export default rootReducer;
